import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeGetDeliveryPromisesExtended, makeGetIsSelectedSizeSoldOut, makeGetProductFulfillment, makeGetProductFulfillmentBySize, makeGetSelectedColorId, makeGetSelectedSku, makeGetSizeCombinationNotExist, } from '../redux/product/selectors/ProductSelector';
import { useAemConfig } from '@as-react/common-components';
import { makeGetBasketClickAndCollectStoreIdState } from '../redux/basket/selectors/BasketSelector';
import { useTranslation } from 'react-i18next';
import { Box, BoxTheme } from '@as/cotopaxi';
import LocalStorageUtil from '../util/LocalStorageUtil';
import { SELECTED_STORE_STORAGE_KEY } from '../constants/StorageKeysConstants';
import { NotifyMeForm } from '../components/notify-me/NotifyMeForm';
import { FreeDeliveryMessage } from '../components/product-detail/free-delivery-message/FreeDeliveryMessage';
import ProductSpecialtyMessageContainer from './product/ProductSpecialtyMessageContainer';
import { productActions } from '../redux/product/actions/ProductActions';
import { DeliveryPromiseLoader } from '../components/product-detail/delivery-promise-v2/delivery-promise-loader/DeliveryPromiseLoader';
import DeliveryPromiseV2 from '../components/product-detail/delivery-promise-v2/DeliveryPromiseV2';
import { getDeliveryExplanation } from '../util/DeliveryPromiseUtil';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import StoreAPI from '../api/store/StoreAPI';
import StoreUtil from '../util/StoreUtil';
import ProductDetailAPI from '../api/ProductDetailAPI';
import { ProductCTAContainerV2 } from './product/ProductCTAContainerV2';
export const DeliveryPromiseContainerExtended = ({ deliveryPromiseExplanations, thresholdFreeDelivery, freeDeliveryMessage, productId, quantity, }) => {
    const aemConfiguration = useAemConfig();
    const { defaultRequestParams, servicesEndpoint, businessUnitId, mainWebShop, isShopLanding, checkoutCc: clickAndCollectEnabled, feature_toggles: { delivery_promise_select_size_label }, } = aemConfiguration;
    const isSelectedSizeSoldOut = useSelector(makeGetIsSelectedSizeSoldOut());
    const selectedSku = useSelector(makeGetSelectedSku());
    const selectedStoreId = useSelector(makeGetBasketClickAndCollectStoreIdState());
    const deliveryPromiseExtended = useSelector(makeGetDeliveryPromisesExtended());
    const sizeCombinationNotExist = useSelector(makeGetSizeCombinationNotExist());
    const fulfillment = useSelector(makeGetProductFulfillment());
    const fulfillmentBySize = useSelector(makeGetProductFulfillmentBySize());
    const selectedColorId = useSelector(makeGetSelectedColorId());
    const dispatch = useDispatch();
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const [storeName, setStoreName] = useState();
    const [storeStockAvailable, setStoreStockAvailable] = useState(false);
    const openCC = () => {
        dispatch(basketActions.createCCPopupOpenAction());
        dispatch(analyticsActions.showStoreStock());
    };
    const sizeForgotten = () => dispatch(basketActions.createSizeForgottenShowAction());
    const showFreeDeliveryMessage = freeDeliveryMessage &&
        delivery_promise_select_size_label &&
        selectedSku &&
        !isSelectedSizeSoldOut &&
        !(fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.hdExcluded) &&
        !(fulfillmentBySize === null || fulfillmentBySize === void 0 ? void 0 : fulfillmentBySize.storeSourceExcluded);
    const fetchProductAvailabilityForCurrentStore = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const storeAvailabilityData = yield ProductDetailAPI.fetchProductAvailabilityForCurrentStore(servicesEndpoint, defaultRequestParams, productId, { storeId: selectedStoreId });
        const isStockAvailable = Boolean((_c = (_b = (_a = storeAvailabilityData === null || storeAvailabilityData === void 0 ? void 0 : storeAvailabilityData.colours) === null || _a === void 0 ? void 0 : _a.find(color => color.idColour === selectedColorId)) === null || _b === void 0 ? void 0 : _b.sizes) === null || _c === void 0 ? void 0 : _c.some(size => Number(size.availableStock) > 0));
        setStoreStockAvailable(isStockAvailable);
    });
    useEffect(() => {
        if (productId && !selectedSku && selectedStoreId) {
            fetchProductAvailabilityForCurrentStore();
        }
    }, [selectedSku, productId, selectedStoreId]);
    useEffect(() => {
        var _a;
        const selectedStoreIdFromLocalStorage = (_a = LocalStorageUtil.getJsonItem(SELECTED_STORE_STORAGE_KEY)) === null || _a === void 0 ? void 0 : _a.storeId;
        if (selectedStoreIdFromLocalStorage || selectedStoreId) {
            const getStoreInfo = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const storeInformation = yield StoreAPI.getStoreInformation(servicesEndpoint, defaultRequestParams, businessUnitId, Number(selectedStoreIdFromLocalStorage) || Number(selectedStoreId));
                    setStoreName(StoreUtil.getStoreName(storeInformation, mainWebShop, t));
                }
                catch (_a) { }
            });
            getStoreInfo();
        }
        else {
            setStoreName(undefined);
        }
    }, [selectedStoreId, selectedSku]);
    useEffect(() => {
        var _a;
        const selectedStoreIdFromLocalStorage = Number((_a = LocalStorageUtil.getJsonItem(SELECTED_STORE_STORAGE_KEY)) === null || _a === void 0 ? void 0 : _a.storeId);
        dispatch(productActions.createGetDeliveryPromiseExtended({
            productId,
            sku: selectedSku,
            selectedStoreId: selectedStoreIdFromLocalStorage || Number(selectedStoreId),
        }));
    }, [selectedSku, productId, selectedStoreId, selectedColorId]);
    if ((deliveryPromiseExtended === null || deliveryPromiseExtended === void 0 ? void 0 : deliveryPromiseExtended.loading) || !deliveryPromiseExtended) {
        return (_jsx(Box, { mobile: { spacing: { marginTop: 2, marginBottom: 2 } }, children: _jsx(DeliveryPromiseLoader, {}) }));
    }
    if (sizeCombinationNotExist) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [showFreeDeliveryMessage && (_jsx(Box, { mobile: { spacing: { marginTop: 1, marginBottom: 1.5 } }, tablet: { spacing: { marginTop: 1.5, marginBottom: 2 } }, children: _jsx(FreeDeliveryMessage, { freeDeliveryMessage: freeDeliveryMessage, thresholdFreeDelivery: thresholdFreeDelivery, withGridWrapper: true }) })), _jsxs(Box, { mobile: {
                    spacing: {
                        paddingBottom: 2,
                        paddingLeft: 2,
                        paddingRight: 2,
                        paddingTop: isSelectedSizeSoldOut ? 0 : 2,
                        marginTop: 2,
                        marginBottom: 2,
                    },
                    theme: BoxTheme.PRIMARY,
                }, children: [!isSelectedSizeSoldOut && deliveryPromiseExtended && (_jsx(DeliveryPromiseV2, { deliveryPromiseExplanation: getDeliveryExplanation(deliveryPromiseExtended === null || deliveryPromiseExtended === void 0 ? void 0 : deliveryPromiseExtended.hdDeliveryPromise, deliveryPromiseExplanations), deliveryPromiseExtended: deliveryPromiseExtended, selectedSku: selectedSku, storeName: storeName, openCC: openCC, sizeForgotten: sizeForgotten, isSelectedSizeSoldOut: isSelectedSizeSoldOut, fulfillment: fulfillment, storeSourceExcluded: fulfillmentBySize === null || fulfillmentBySize === void 0 ? void 0 : fulfillmentBySize.storeSourceExcluded, clickAndCollectEnabled: clickAndCollectEnabled, storeStockAvailable: storeStockAvailable })), !isShopLanding && isSelectedSizeSoldOut && _jsx(NotifyMeForm, { withNewDesign: true }), !isSelectedSizeSoldOut && (_jsxs(_Fragment, { children: [_jsx(ProductCTAContainerV2, { quantity: quantity }), _jsx(ProductSpecialtyMessageContainer, {})] }))] })] }));
};
